/**
 * The work replay on the candidate page is off unless a build sets
 * REACT_APP_WORK_REPLAY=true. With it off, the candidate page is exactly as
 * before: no section, and no request to /work-replay.
 *
 * Read at call time, not import time, so a test can turn it on for one case.
 */
export const isWorkReplayEnabled = (): boolean =>
  process.env.REACT_APP_WORK_REPLAY === 'true';
